export const LIST_ITEM_NOTE = 'note'
export const LIST_ITEM_PLACEHOLDER = 'placeholder'
export const LIST_ITEM_LOADER = 'loader'

export const LIST_KEY_ROOT = 'root'

export const LIST_ITEM_INDENT_PADDING = 24
